module.exports = __webpack_public_path__ + "7d6a4b576a6e6c7bfc57cc716dbf9575.pdf";